const autocompleteFormParamUser = {
  sites: 'Sites',
  companies: 'Empresa Terceira'
};

export default autocompleteFormParamUser;
